export default __webpack_public_path__ + "static/media/Frame_191.0791eb42.jpg";